import { Banner, AIImage, BlueLarge } from "../../images/index";
import { useEffect, useRef, useState } from "react";
import ScrollToTopButton from "../../components/ScrollToTopButton";
import { Frame15, Frame16, Frame17, image331 } from "../../images/Services";
import { useNavigate } from "react-router-dom";
import useSlug from "../SlugComp";
import { getPagesBySlug } from "../../services/apiService";
import SEO from "../Seo";

const sections = [
  {
    id: "what-we-deliver",
    title: "What We Deliver",
    points: [
      "24/7 Security Operations (SOC) & incident response",
      "Cloud & infrastructure security",
      "Threat detection & vulnerability management",
      "Compliance programs (PCI DSS, HIPAA, GDPR, NIST)",
      "Employee security awareness training",
    ],
    img: Frame15,
  },
  {
    id: "business-impact",
    title: "Business Impact",
    points: [
      "Stronger protection against cyber threats",
      "Reduced risks with proactive monitoring",
      "Full compliance with industry standards",
      "Increased trust from customers and partners",
    ],
    img: Frame16,
  },
  {
    id: "case-example",
    title: "Case Example",
    mainPoints: [
      "Built a CyberSecurity modernization program for a U.S. public agency",
      "Designed a retail threat protection framework",
      "Implemented SOC services for a healthcare provider",
    ],
    points: [
      "Achieved full NIST compliance",
      "Reduced cyber incidents by 40%",
      "Ensured 24/7 monitoring & response",
    ],
    img: Frame17,
  },
];

function CSC() {
  const navigate = useNavigate();
  const [activeSection, setActiveSection] = useState(sections[0].id);
  const handleClick = () => {
    navigate("/contact");
  };
  const sectionRefs = useRef({});
  const slug = useSlug();
  const [metaData, setMetaData] = useState({});

  useEffect(() => {
    sections.forEach((section) => {
      sectionRefs.current[section.id] = document.getElementById(section.id);
    });

    const fetchData = async () => {
      const data = await getPagesBySlug(slug.toLowerCase());
      setMetaData(data.data);
    };

    fetchData();

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActiveSection(entry.target.id);
          }
        });
      },
      {
        root: null,
        rootMargin: "-50% 0px -50% 0px",
        threshold: 0,
      }
    );
    Object.values(sectionRefs.current).forEach((sectionEl) => {
      if (sectionEl) observer.observe(sectionEl);
    });
    return () => {
      observer.disconnect();
    };
  }, [sections, slug]);

  const scrollToSection = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };
  return (
    <>
      <SEO {...metaData} />
      <div>
        <div className="relative min-h-[500px]">
          <img
            src={Banner}
            alt="About Banner"
            className="absolute inset-0 -z-10 md:h-full h-[calc(100vh-0px)] w-full object-cover"
          />

          <div className="absolute flex items-center justify-between h-full sm:w-[75rem] [@media(min-width:1920px)]:w-[84rem] mx-auto left-0 right-0 px-8 sm:px-6 md:px-8 lg:px-8 xl:px-0">
            <div className="max-w-[48rem] font-roboto space-y-6 mt-16">
              <span className="flex items-center font-bold text-lg tracking-wider space-x-2">
                <span className="w-[21px] h-[6px] bg-activeColor"></span>
                <span className="w-[36px] h-[6px] bg-activeColor"></span>
                <span className="text-[#475569]">Our Services</span>
              </span>
              <h1 className="text-4xl md:text-7xl text-[#29327f] font-bold">
                CyberSecurity Compliance
              </h1>
              <p className="text-lg text-[#404040] font-600">
                TechProject <span className="text-gray-500 text-lg">‹‹</span>{" "}
                Services <span className="text-gray-500 text-lg">‹‹</span>{" "}
                CyberSecurity & Compliance
              </p>
            </div>

            <div className="max-w-xl flex justify-end mt-16">
              <img src={image331} alt="IT Hiring" className="w-full h-auto" />
            </div>
          </div>
        </div>

        <div className="sm:w-[75rem] [@media(min-width:1920px)]:w-[84rem] mx-auto w-full py-10 px-8 sm:px-6 md:px-8 lg:px-8 xl:px-0 bg-white font-roboto flex flex-col items-center">
          <div className="text-center mb-3 space-y-6">
            <span className="flex items-center justify-center font-bold text-lg tracking-wider space-x-2">
              <span className="w-[21px] h-[6px] bg-activeColor"></span>
              <span className="w-[36px] h-[6px] bg-activeColor"></span>
            </span>
            {/* <h1 className="text-3xl md:text-7xl font-extrabold text-[#434253] mb-2">
            CyberSecurity Compliance
          </h1> */}
            <p className="text-[#404040] font-bold text-lg">
              We help businesses stay secure and compliant in a fast-changing
              digital world. From data protection to regulatory compliance,
              TechProjects ensures your systems, people, and processes are safe.
            </p>
          </div>

          <div className="flex flex-col gap-10 md:flex-row min-h-screen mt-12">
            <div className="md:w-2/4 w-full md:sticky md:top-24 text-white p-4 h-fit self-start space-y-3 rounded-lg">
              {sections.map((section) => (
                <button
                  key={section.id}
                  onClick={() => scrollToSection(section.id)}
                  className={`w-full text-left text-2xl font-500 px-4 py-3 rounded-md transition-all border-l-4 ${
                    activeSection === section.id
                      ? "bg-activeColor text-white border-red-500"
                      : "text-[#0F172A] hover:bg-[#FA3746]/10 border-transparent"
                  }`}
                >
                  {section.title}
                </button>
              ))}
            </div>

            <div className="md:w-3/4 w-full p-8 space-y-24 bg-[#F3F3F3]">
              {sections.map((section) => (
                <div
                  key={section.id}
                  id={section.id}
                  className="scroll-mt-40 text-center px-10"
                >
                  <h2 className="text-4xl text-left font-extrabold text-[#434253] mb-6">
                    {section.title}
                  </h2>

                  <img
                    src={section.img}
                    alt={section.title}
                    className="object-contain mx-auto mb-6"
                  />

                  <ul className="md:w-3/4 list-disc text-lg space-y-4 text-left">
                    {section.mainPoints && section.mainPoints.length > 0
                      ? section.mainPoints.map((mainPoint, idx) => (
                          <li
                            className="text-[#0F172A] font-semibold"
                            key={idx}
                          >
                            {mainPoint}
                            {section.points && section.points[idx] && (
                              <ul className="space-y-1 mt-1">
                                <li className="text-[#475569] font-400">
                                  {section.points[idx]}
                                </li>
                              </ul>
                            )}
                          </li>
                        ))
                      : section.points &&
                        section.points.map((point, idx) => (
                          <li className="text-[#475569] font-400" key={idx}>
                            {point}
                          </li>
                        ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        </div>

        <section
          className="text-white flex items-center py-8 md:py-[4rem] relative overflow-hidden bg-cover bg-no-repeat font-roboto"
          style={{ backgroundImage: `url(${BlueLarge})` }}
        >
          <div className="sm:w-[75rem] [@media(min-width:1920px)]:w-[84rem] mx-auto text-center px-3 md:px-6">
            <h2 className="text-3xl md:text-4xl xl:text-6xl max-w-4xl mx-auto font-extrabold text-white leading-tight mb-[2rem] md:mb-[3rem]">
              Let’s Build Your Team Together
            </h2>
            <p className="text-lg font-400 text-[#CBD5E1] max-w-3xl  mx-auto">
              Have questions or want to learn more about TechProjects? We’re
              here to help. Whether you're a job seeker, client, or partner, our
              team is ready to assist you.
            </p>
            <div className="flex flex-wrap  justify-center mt-10 gap-6 md:gap-12">
              <button
                onClick={handleClick}
                type="submit"
                className="bg-activeColor text-white text-lg md:text-2xl px-5 md:px-6 py-2 md:py-3 rounded-md font-medium hover:bg-red-600 transition-all flex items-center gap-4"
              >
                Contact Us Now
              </button>
            </div>
          </div>
        </section>
        <ScrollToTopButton />
      </div>
    </>
  );
}

export default CSC;
